import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RestApiService } from '../shared/rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class ProgrammeService {

  endpoint: string = 'organisation';
  period!: string;
  //curriculumPeriod = environment.curriculumPeriod; //pituus
  queryParam!: string; //= '?period=2022-2024';

  constructor(private api: RestApiService) { }


  getProgrammes(unitId: any): Observable<any[]> {
    return this.api.getList(`programme/${unitId}/list`);
  }
  getProgrammeDescription(unitId: any): Observable<any[]> {
    return this.api.getList(`programme/${unitId}/description`);
  }
  getProgrammeWithLearningUnit(unitId: any): Observable<any[]> {
    // return this.api.getOne<Programme[]>('lu', unitId);
    return this.api.getOne('accomplishment-plan', unitId);
  }
  getRelatedProgrammes(id: any): Observable<any[]> {
    return this.api.getList(`programme/course/${id}`);
  }
  getLearningPaths(id: any) : any {
    return this.api.getList(`learning-path/${id}`);
  }
  getAccomplishmentPlan(accomplishmentPlanId: any) {
    return this.api.getList(`accomplishment-plan/plan/${accomplishmentPlanId}`);
  }
  getAccomplishmentPlanList(id: any) : any {
    return this.api.getList(`accomplishment-plan/list/${id}`);
  }

  getPeriodCountByYear(year: any, duration: any) : any {
    return this.api.getList(`accomplishment-plan/period-count/${year}/${duration}`);
  }

  
}
